import { invokeModuleMethod } from './moduleRuntimeHelpers.js';

export function createCoreUiActionFacade(context = {}) {
  const {
    ensureAppEventBindingsModuleReady,
    getAppEventBindingsModuleApi,
    ensureBookshelfInteractionsModuleReady,
    getBookshelfInteractionsModuleApi,
    ensureThoughtModalModuleReady,
    getThoughtModalModuleApi,
    ensureEssaysEditorModuleReady,
    getEssaysEditorModuleApi,
    ensureModalCoreModuleReady,
    getModalCoreModuleApi,
    ensureBookDeleteModalModuleReady,
    getBookDeleteModalModuleApi,
    ensureThoughtsMobileSidebarModuleReady,
    getThoughtsMobileSidebarModuleApi,
    getCurrentView,
    showToast
  } = context;

  const noOp = () => {};
  const showError = (message) => {
    if (typeof showToast === 'function') {
      showToast(message);
    }
  };

  function setupEventListeners() {
    invokeModuleMethod(getAppEventBindingsModuleApi, ensureAppEventBindingsModuleReady, 'setupEventListeners', [], noOp);
  }

  function setupBookshelfDelegatedEvents() {
    invokeModuleMethod(
      getBookshelfInteractionsModuleApi,
      ensureBookshelfInteractionsModuleReady,
      'setupBookshelfDelegatedEvents',
      [],
      noOp
    );
  }

  function openThoughtModal(thoughtOrBook = null) {
    invokeModuleMethod(
      getThoughtModalModuleApi,
      ensureThoughtModalModuleReady,
      'openThoughtModal',
      [thoughtOrBook],
      () => showError('思索弹窗加载失败')
    );
  }

  async function createNewEssay() {
    try {
      const mod = await ensureEssaysEditorModuleReady();
      await mod?.createNewEssay?.();
    } catch {
      showError('随笔模块加载失败');
    }
  }

  function handleEssayTitleChange() {
    invokeModuleMethod(getEssaysEditorModuleApi, ensureEssaysEditorModuleReady, 'handleEssayTitleChange', [], noOp);
  }

  async function deleteCurrentEssay() {
    try {
      const mod = await ensureEssaysEditorModuleReady();
      await mod?.deleteCurrentEssay?.();
    } catch {
      showError('随笔模块加载失败');
    }
  }

  function toggleEssaysSidebar() {
    invokeModuleMethod(getEssaysEditorModuleApi, ensureEssaysEditorModuleReady, 'toggleEssaysSidebar', [], noOp);
  }

  function renderEssays() {
    const api = typeof getEssaysEditorModuleApi === 'function' ? getEssaysEditorModuleApi() : null;
    if (typeof api?.renderEssays === 'function') {
      api.renderEssays();
      return;
    }

    ensureEssaysEditorModuleReady()
      .then((mod) => {
        if (typeof getCurrentView === 'function' && getCurrentView() === 'essays') {
          mod?.renderEssays?.();
        }
      })
      .catch(() => {
        if (typeof getCurrentView === 'function' && getCurrentView() === 'essays') {
          showError('随笔模块加载失败');
        }
      });
  }

  function openModal() {
    invokeModuleMethod(getModalCoreModuleApi, ensureModalCoreModuleReady, 'openModal', [], noOp);
  }

  function closeModal() {
    invokeModuleMethod(getModalCoreModuleApi, ensureModalCoreModuleReady, 'closeModal', [], noOp);
  }

  function initModalDrag() {
    invokeModuleMethod(getModalCoreModuleApi, ensureModalCoreModuleReady, 'initModalDrag', [], noOp);
  }

  function confirmDeleteBook(bookId) {
    invokeModuleMethod(
      getBookDeleteModalModuleApi,
      ensureBookDeleteModalModuleReady,
      'confirmDeleteBook',
      [bookId],
      () => showError('删除模块加载失败')
    );
  }

  function initThoughtsMobileSidebarToggleBridge() {
    invokeModuleMethod(
      getThoughtsMobileSidebarModuleApi,
      ensureThoughtsMobileSidebarModuleReady,
      'initThoughtsMobileSidebarToggle',
      [],
      noOp
    );
  }

  return {
    setupEventListeners,
    setupBookshelfDelegatedEvents,
    openThoughtModal,
    createNewEssay,
    handleEssayTitleChange,
    deleteCurrentEssay,
    toggleEssaysSidebar,
    renderEssays,
    openModal,
    closeModal,
    initModalDrag,
    confirmDeleteBook,
    initThoughtsMobileSidebarToggleBridge
  };
}
